const {Vector3}  = THREE;

export default {
    arrow: {
        color: 0xFFFF00,
    },

    cylinder: {
        opacity: wv.annotationArrowOpacity
    },

    bindPose: new Vector3(0, 1, 0)
};
